import * as React from 'react';
import { colors } from '../styles/colors';
import { ModalActionButton } from './ModalActionButton';

interface IProps {
    headerText: string;
    onConfirmClick?(): void;
    confirmText?: string;
    isFixed?: boolean;
}

export class ExitableAlert extends React.Component<IProps> {
    public render() {
        return (
            <div style={styles.fixedFill}>
                <div style={styles.innerContainer}>
                    <p style={styles.headerText}>{this.props.headerText}</p>
                    {this.props.onConfirmClick && this.props.confirmText && (
                        <div style={styles.buttonContainer}>
                            <ModalActionButton buttonText={this.props.confirmText} fontStyle={styles.buttonFont} onClick={this.props.onConfirmClick} />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const styles = {
    buttonFont: {
        fontSize: 14
    },
    fixedFill: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: colors.DARK_BACKGROUND,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999999
    } as React.CSSProperties,
    absoluteFill: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: colors.DARK_BACKGROUND,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999
    } as React.CSSProperties,
    innerContainer: {
        width: 450,
        backgroundColor: colors.LIGHT_GREY,
        display: 'flex',
        flexDirection: 'column',
        padding: 50
    } as React.CSSProperties,
    headerText: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        opacity: 0.8,
        fontWeight: 'bold',
        marginBottom: 15
    } as React.CSSProperties,
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        paddingTop: 15
    } as React.CSSProperties,
    confirmButton: {
        height: 50,
        borderRadius: 5,
        width: 160
    },
    cancelButton: {
        height: 50,
        borderRadius: 5,
        width: 160
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/ExitableAlert.tsx